import React from 'react'
import { InboxOutlined } from '@ant-design/icons'
import { Upload, Modal, message } from "antd"

import { handleError } from '../../../helpers'
import { replaceContest } from '../services'

const { Dragger } = Upload

export default function ContestCoverImageModal({ 
    visible, onClose, contest, reload
}) {

    const props = {
        multiple: false,
        customRequest: async ({ file, onError, onSuccess: handleSuccess }) => {
            const fileExt = file.name.split('.').pop().toLowerCase()

            const values = new FormData()
            values.append('cover_image_file', file)
            values.append('cover_image_path', `app/contests/${new Date().getTime()}.${fileExt}`)
            values.append('_method', 'PUT')

            try {
                const response = await replaceContest(contest.id, values)
                handleSuccess(response.data, file)
                message.success('Imagen actualizada')
                reload()
                onClose()
            } catch (error) {
                onError(error)
                handleError(error)
                console.error('Error al subir el archivo: ', error.message)
            }
        }
    };

    return (
        <Modal 
            visible={visible} 
            onCancel={onClose} 
            footer={null}
            title={`Portada del Concurso: ${contest.name}`}
        >
            { contest.cover_image_url && (
                <img 
                    src={contest.cover_image_url} 
                    alt="Imagen de Portada" 
                    style={{ width: '100%', height: 'auto', marginBottom: 10 }}
                />
            )}
            <Dragger {...props}>
                <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                    Haga clic o arrastre el adjunto
                </p>
                <p className="ant-upload-hint">
                    Solo se permite adjuntar archivos menores a 5MB.
                </p>
            </Dragger>
        </Modal>
    )
}
